document.addEventListener('DOMContentLoaded', function() {
   setTimeout(function(){
       document.body.classList.add('page___loaded');
   },100)
    const draggableElements = document.querySelectorAll('.background-pattern-image');
    draggableElements.forEach(draggableBackground => {
        let isDragging = false;
        let startX, startY;
        let backgroundPositionX = 0, backgroundPositionY = 0;

        draggableBackground.addEventListener('mousedown', function(e) {
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            draggableBackground.style.cursor = 'grabbing';
        });

        document.addEventListener('mousemove', function(e) {
            if (isDragging) {
                let dx = e.clientX - startX;
                let dy = e.clientY - startY;

                backgroundPositionX += dx;
                backgroundPositionY += dy;

                draggableBackground.style.backgroundPosition = `${backgroundPositionX}px ${backgroundPositionY}px`;

                startX = e.clientX;
                startY = e.clientY;
            }
        });

        document.addEventListener('mouseup', function() {
            isDragging = false;
            draggableBackground.style.cursor = 'move';
        });
    });

    document.querySelectorAll('.pattern-background-slider-container').forEach((sliderContainer, index) => {
        const sliderThumb = sliderContainer.querySelector('.pattern-background-slider-thumb');
        const increaseBtn = sliderContainer.querySelector('.pattern-background-button:nth-child(1)');
        const decreaseBtn = sliderContainer.querySelector('.pattern-background-button:nth-child(3)');

        let isDragging = false;
        let sliderValue = 50; // Initial value
        const minValue = 0; // Minimum value

        function updateSlider(positionPercentage) {
            let offsetPercentage = Math.max(minValue, Math.min(positionPercentage, 100));
          
           if (offsetPercentage > 97) {
                sliderThumb.style.bottom = '97%';
            } else {
                sliderThumb.style.bottom = `${offsetPercentage}%`;
            }

            sliderValue = offsetPercentage;

            // const minSize = 20;
            // const maxSize = 97;
            const minSize = 50;
            const maxSize = 150;
            const normalizedValue = ((sliderValue / 100) * (maxSize - minSize)) + minSize;
            const backgroundSize = Math.min(maxSize, Math.max(minSize, normalizedValue));

            const backgroundPatternImage = sliderContainer.closest('.image-wrap').querySelector('.background-pattern-image');
            backgroundPatternImage.style.backgroundSize = `${backgroundSize}%`;
        }

        updateSlider(sliderValue);

        sliderThumb.addEventListener('mousedown', function (e) {
            isDragging = true;
            document.body.style.userSelect = 'none';
        });

        document.addEventListener('mousemove', function (e) {
            if (isDragging) {
                const rect = sliderContainer.getBoundingClientRect();
                const offsetY = e.clientY - rect.top;
                const sliderHeight = sliderContainer.clientHeight - 40;

                let positionPercentage = ((sliderHeight - offsetY) / sliderHeight) * 100;

                positionPercentage = Math.max(minValue, Math.min(positionPercentage, 100));

                updateSlider(positionPercentage);
            }
        });

        document.addEventListener('mouseup', function () {
            isDragging = false;
            document.body.style.userSelect = '';
        });

        increaseBtn.addEventListener('click', function () {
            let newPositionPercentage = sliderValue + 10;
            newPositionPercentage = Math.min(newPositionPercentage, 100);
            updateSlider(newPositionPercentage);
        });

        decreaseBtn.addEventListener('click', function () {
            let newPositionPercentage = sliderValue - 10;
            newPositionPercentage = Math.max(newPositionPercentage, minValue);
            updateSlider(newPositionPercentage);
        });
    });


    document.querySelectorAll('.pattern-saturation-slider-container').forEach((sliderContainer, index) => {
    const sliderThumb = sliderContainer.querySelector('.pattern-saturation-slider-thumb');
    const increaseBtn = sliderContainer.querySelector('.pattern-saturation-button:nth-child(1)');
    const decreaseBtn = sliderContainer.querySelector('.pattern-saturation-button:nth-child(3)');

    let isDragging = false;
    let sliderValue = 50; // Initial saturation value
    const minValue = 0; // Minimum saturation value

    function updateSlider(positionPercentage) {
        let offsetPercentage = Math.max(minValue, Math.min(positionPercentage, 100));
      if (offsetPercentage > 97) {
        sliderThumb.style.left = `97%`;
      }else{
        sliderThumb.style.left = `${offsetPercentage}%`;
        
      }
        
        sliderValue = offsetPercentage;

        // Calculate and apply saturation
        const minSaturation = 0;
        const maxSaturation = 200;
        const saturationValue = ((sliderValue / 100) * (maxSaturation - minSaturation)) + minSaturation;

      document.querySelectorAll('.background-pattern-container-wrap .image-wrap .background-pattern-image').forEach(function(object){
        object.style.filter = `saturate(${saturationValue}%)`;
      })

        
    }

    updateSlider(sliderValue);

    sliderThumb.addEventListener('mousedown', function (e) {
        isDragging = true;
        document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
        if (isDragging) {
            const rect = sliderContainer.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const sliderWidth = sliderContainer.clientWidth - 40;

            let positionPercentage = (offsetX / sliderWidth) * 100;
            positionPercentage = Math.max(minValue, Math.min(positionPercentage, 100));

            updateSlider(positionPercentage);
        }
    });

    document.addEventListener('mouseup', function () {
        isDragging = false;
        document.body.style.userSelect = '';
    });

    increaseBtn.addEventListener('click', function () {
        let newPositionPercentage = sliderValue - 10;
        newPositionPercentage = Math.min(newPositionPercentage, 100);
        updateSlider(newPositionPercentage);
    });

    decreaseBtn.addEventListener('click', function () {
        let newPositionPercentage = sliderValue + 10;
        newPositionPercentage = Math.max(newPositionPercentage, minValue);
        updateSlider(newPositionPercentage);
    });
});


  document.querySelectorAll('.pattern-hue-slider-container').forEach((sliderContainer, index) => {
    const sliderThumb = sliderContainer.querySelector('.pattern-hue-slider-thumb');
    const increaseBtn = sliderContainer.querySelector('.pattern-hue-button:nth-child(1)');
    const decreaseBtn = sliderContainer.querySelector('.pattern-hue-button:nth-child(3)');

    let isDragging = false;
    let sliderValue = 0; // Initial hue value
    const minValue = 0; // Minimum hue value

    function updateSlider(positionPercentage) {
        let offsetPercentage = Math.max(minValue, Math.min(positionPercentage, 100));

        // Set the horizontal position of the thumb
       if (offsetPercentage > 97) {
        sliderThumb.style.left = `97%`;
       }else{
        sliderThumb.style.left = `${offsetPercentage}%`;
       }
        sliderValue = offsetPercentage;

        // Calculate and apply hue-rotate
        const minHue = 0;
        const maxHue = 360;
        const hueValue = ((sliderValue / 100) * (maxHue - minHue)) + minHue;

        // const backgroundPatternImage = sliderContainer.closest('.image-wrap').querySelector('.background-pattern-image');
        // backgroundPatternImage.style.filter = `hue-rotate(${hueValue}deg)`;

       document.querySelectorAll('.background-pattern-container-wrap .image-wrap .background-pattern-image').forEach(function(object){
        object.style.filter = `hue-rotate(${hueValue}deg)`;
      })
    }

    updateSlider(sliderValue);

    sliderThumb.addEventListener('mousedown', function (e) {
        isDragging = true;
        document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
        if (isDragging) {
            const rect = sliderContainer.getBoundingClientRect();
            const offsetX = e.clientX - rect.left;
            const sliderWidth = sliderContainer.clientWidth - sliderThumb.clientWidth;

            let positionPercentage = (offsetX / sliderWidth) * 100;
            positionPercentage = Math.max(minValue, Math.min(positionPercentage, 100));

            updateSlider(positionPercentage);
        }
    });

    document.addEventListener('mouseup', function () {
        isDragging = false;
        document.body.style.userSelect = '';
    });

    increaseBtn.addEventListener('click', function () {
        let newPositionPercentage = sliderValue - 10;
        newPositionPercentage = Math.min(newPositionPercentage, 100);
        updateSlider(newPositionPercentage);
    });

    decreaseBtn.addEventListener('click', function () {
        let newPositionPercentage = sliderValue + 10;
        newPositionPercentage = Math.max(newPositionPercentage, minValue);
        updateSlider(newPositionPercentage);
    });
});



});
